import React from 'react';
import { Row, Col } from 'antd';
import styles from './SplitPaneLayout.module.css';

interface SplitPaneLayoutProps {
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
  leftWidth?: number | { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };
  rightWidth?: number | { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };
  showRight?: boolean;
  className?: string;
}

/**
 * Standardized split-pane layout component for management pages
 * 
 * Provides a consistent left-right layout pattern:
 * - Left pane: List/table of items
 * - Right pane: Details form for selected item
 * 
 * Responsive: Stacks vertically on mobile devices
 */
export const SplitPaneLayout: React.FC<SplitPaneLayoutProps> = ({
  leftContent,
  rightContent,
  leftWidth = { xs: 24, lg: 10, xl: 10 },
  rightWidth = { xs: 24, lg: 14, xl: 14 },
  showRight = true,
  className = '',
}) => {
  return (
    <div className={`${styles.splitPaneLayout} ${className}`}>
      <Row gutter={16} className={styles.splitPaneRow}>
        {/* Left Pane - List/Table */}
        <Col 
          {...(typeof leftWidth === 'number' 
            ? { span: leftWidth } 
            : leftWidth
          )}
          className={styles.splitPaneLeft}
        >
          {leftContent}
        </Col>

        {/* Right Pane - Details Form */}
        {showRight && (
          <Col 
            {...(typeof rightWidth === 'number' 
              ? { span: rightWidth } 
              : rightWidth
            )}
            className={styles.splitPaneRight}
          >
            {rightContent}
          </Col>
        )}
      </Row>
    </div>
  );
};

